import Vue from 'vue'
import Vuex from 'vuex'
import rewardlink from '@/store/modules/reward_link'
import cart from '@/store/modules/cart'
import app from '@/store/modules/app'
import order from '@/store/modules/order'
import recipientData from '@/store/modules/recipient'
import catalog from '@/store/modules/catalog'
import analytics from '@/store/modules/analytics'
import feedback from '@/store/modules/feedback'
// Have to disable casing enforcement for this next line due to it being a possible Vuex state breaking change
// that is not worth risking in a linter standardization MR.
// eslint-disable-next-line camelcase
import redemption_history from '@/store/modules/redemption_history'
import wallet from '@/store/modules/wallet'
import directPayment from '@/store/modules/direct_payment'
import vuexInjectionProvider from '@/store/modules/vuex_injection_provider'
import { vuexLocalStorage, vuexSessionStorage } from './vuex-local-storage'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    rewardlink,
    cart,
    app,
    order,
    recipientData,
    catalog,
    analytics,
    feedback,
    redemption_history,
    wallet,
    directPayment,
    vuexInjectionProvider
  },
  plugins: [vuexSessionStorage.plugin, vuexLocalStorage.plugin]
})
